module.exports = __webpack_public_path__ + "static/media/MOLDURA_PES_ISTAMBUL_2023_02-TOPKAPI.a56f3755.png";